import styled from "styled-components";

import { grayScale, getOpacityColor } from "@enkor/design/colors";
import { APP_SIZE } from "@styles/variables";

export const BUTTON_BOX = {
  BUTTON_HEIGHT: 48,
  PADDING: 16,
};

export const BottomButtonBox = styled.div<{ $shouldFixSafeArea?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  margin-top: auto;
  padding: ${BUTTON_BOX.PADDING}px;

  padding-bottom: ${({ $shouldFixSafeArea }) =>
    $shouldFixSafeArea ? BUTTON_BOX.PADDING : "env(safe-area-inset-bottom)"};

  border-top: 1px solid ${grayScale.main};

  background: ${getOpacityColor(grayScale[200], 0.7)};

  transform: translateX(-50%);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`;
